import { generateStripeState } from "@/services/vuex.service";

const options = {
  api: {
    list: () => `/api/stripe/paymentMethod`,
    update: ({ id }: { id: string }) => `/api/stripe/paymentMethod/${id}`,
    delete: ({ id }: { id: string }) => `/api/stripe/paymentMethod/${id}`,
    create: () => `/api/stripe/paymentMethod`,
    get: ({ id }: { id: string }) => `/api/stripe/paymentMethod/${id}`,
  },
  state: {
    collectionName: "paymentMethod",
  },
  getters: {
    getPagination: "getPaymentMethodPagination",
    getCollection: "getPaymentMethods",
    getLoading: "getPaymentMethodsLoading",
    getListLoading: "getListPaymentMethodsLoading",
    getCreateLoading: "getCreatePaymentMethodsLoading",
    getUpdateLoading: "getUpdatePaymentMethodsLoading",
    getDeleteLoading: "getDeletePaymentMethodsLoading",
  },
  actions: {
    list: "listPaymentMethods",
    update: "updatePaymentMethod",
    create: "createPaymentMethod",
    get: "getPaymentMethod",
    delete: "deletePaymentMethod",
  },
  mutationKey: "PAYMENT_METHODS",
};

const {
  state: stripeState,
  getters: stripeGetters,
  actions: stripeActions,
  mutations: stripeMutations,
} = generateStripeState(options);

export default {
  namespaced: true,
  state: (): any => ({
    ...stripeState,
  }),
  getters: {
    ...stripeGetters,
  },
  mutations: {
    ...stripeMutations,
  },
  actions: {
    ...stripeActions,
  },
};
